export const AVAILABLE = 'available';
export const UNAVAILABLE = 'unavailable';
export const TLD_NOT_SUPPORTED = 'tld_not_supported';
export const TOOSHORT = 'tooshort';
export const TOOLONG = 'toolong';
export const IDN_ONLY = 'idn_only';
export const IDN_NOT_ALLOWED = 'idn_not_allowed';
export const INVALID = 'invalid';
export const IS_TLD = 'is_tld';
export const IS_LATIN_AND_NON_LATIN = 'latin_and_non_latin';
export const MISSED_TLD = 'missedTld';

